import queryString from 'query-string';

import { getApiRequestFromSearchQuery } from 'utils/searchQuery';

import { fetchOfferPage } from 'redux/modules/search-and-browse/actions/fetch-offer-page';
import setCurrentPageDepthFromPathname from 'redux/modules/page/actions/set-page-depth-using-pathname';

export const offersFetcher =
  ({
    location: { pathname, search: query, state } = {},
    match: { params: { offerType = null } = {} } = {},
  } = {}) =>
  dispatch => {
    const { categoryId: category } = queryString.parse(query);
    const { filterTags = [], sortBy = 'MOST_POPULAR' } = getApiRequestFromSearchQuery(query) || {};

    dispatch(setCurrentPageDepthFromPathname(pathname));

    return dispatch(
      fetchOfferPage({
        params: {
          ...(category && { category }),
          filterTags,
          ...(offerType && { offerType }),
          sortBy,
        },
        refinement: !!state?.refinement,
      }),
    );
  };
